export function addBackendPrefix(path: string) : string {
  // check that incoming path starts with slash
  if (!path.match(/^\//)) {
    throw new Error("oopsie in addBackendPrefix");
  }
  
  const basename = process.env.REACT_APP_BASENAME;

  if (basename) {
    console.log(`adding ${basename}+${path}`);
    return basename+path;
  } else {
    return path;
  }
}
